const EXCLUDED_REFRESH_ENDPOINTS = ["/auth/refresh-token", "/auth/login"];

export const isRefreshRetryAllowed = ({
  status,
  requestUrl,
  hasOriginalRequest,
  hasRetried,
}) => {
  if (!hasOriginalRequest || hasRetried || status !== 401) {
    return false;
  }

  return !EXCLUDED_REFRESH_ENDPOINTS.some((endpoint) =>
    String(requestUrl || "").includes(endpoint)
  );
};

export const hasUsableRefreshToken = (refreshToken) =>
  typeof refreshToken === "string" && refreshToken.length > 0;

export const extractRotatedTokens = (payload) => {
  const token = payload?.token || null;
  const refreshToken = payload?.refresh_token || null;
  if (!token || !refreshToken) {
    throw new Error("Refresh response is missing tokens.");
  }

  return { token, refreshToken };
};

